import { Box, Typography } from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { IBoardSlip } from '../../routes/board-slips/BoardSlipsData';
import { slipInfoWrapStyle, slipWrapStyle } from './styled';

export const SlipComp: FC<Record<"slip", IBoardSlip>> = ({ slip }) => {
  const { id, jobQty, dockName, vesselName, startTime, colour, jobName, isGroup } = slip;
  return (
    <Box sx={{ display: 'flex' }}>
      <Box sx={slipWrapStyle}>
        <Link to={id ? `/slip-preview-slip/${isGroup ? `groupId/${id}` : `${id}`}` : '#'}>
          <img
            style={{ position: 'relative', top: '5px' }}
            src={`/assets/images/${colour.toLowerCase()}_slip.png`}
            alt="SLIP PREVIEW"
            width={40}
            height={80}
          />
        </Link>
      </Box>
      <Box sx={slipInfoWrapStyle}>
        <Typography sx={{ mb: 1 }}>Qty: {jobQty} - {jobName}</Typography>
        <Typography>{dockName}</Typography>
        <Typography>{vesselName}</Typography>
        <Typography>{startTime}</Typography>
      </Box>
    </Box>
  )
}